"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _useUniqueId = require("../utils/useUniqueId");
var _ListContext = require("./_ListContext");
var _ListItem = require("./_ListItem");
var _listboxUtils = require("./_listboxUtils");
var _List = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./List.css") : void 0);
var _excluded = ["children", "className", "expandable", "isRoot", "label", "labelProps", "listPrefixContent"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CSS_BLOCK = 'sapcnqr-list';
var ListGroup = exports.ListGroup = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _expandable$localized, _expandable$localized2;
  var children = props.children,
    className = props.className,
    expandable = props.expandable,
    isRoot = props.isRoot,
    label = props.label,
    labelProps = props.labelProps,
    listPrefixContent = props.listPrefixContent,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  var _ref = listContextValue || {},
    isUsingGroups = _ref.isUsingGroups,
    type = _ref.type;
  var classnames = _bind.default.bind(_List.default);
  var _useState = (0, _react.useState)(typeof (expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded) !== 'undefined' ? expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded : true),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var labelId = (0, _useUniqueId.useUniqueId)();
  var ariaLabelledby = otherProps['aria-labelledby'];
  var generatedIDs = (0, _listboxUtils.getAriaLabelledBy)({
    ariaLabelledby: ariaLabelledby,
    label: label,
    labelId: labelId
  });
  var onExpandButtonKeyDown = function onExpandButtonKeyDown(event) {
    if ((0, _keycode.default)(event) === 'space' || (0, _keycode.default)(event) === 'enter') {
      var _expandable$onToggle;
      event.preventDefault();
      var isExpanded = !expanded;
      setExpanded(isExpanded);
      expandable === null || expandable === void 0 || (_expandable$onToggle = expandable.onToggle) === null || _expandable$onToggle === void 0 || _expandable$onToggle.call(expandable, event, isExpanded);
    }
  };
  (0, _react.useEffect)(function () {
    if (typeof (expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded) !== 'undefined') {
      setExpanded(!!(expandable !== null && expandable !== void 0 && expandable.isExpanded));
    }
  }, [expandable === null || expandable === void 0 ? void 0 : expandable.isExpanded]);
  var listItemProps = isRoot ? undefined : {
    isGroupHeader: isUsingGroups
  };
  var RootElement = isRoot ? _react.default.Fragment : _ListItem.ListItem;
  var ListElement = type === 'ordered' ? 'ol' : 'ul';
  var classes = classnames(CSS_BLOCK, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--collapsed"), expandable && !expanded), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--expanded"), expandable && expanded), className);
  var labelClasses = classnames("".concat(CSS_BLOCK, "__label"), labelProps === null || labelProps === void 0 ? void 0 : labelProps.className);
  var labelContent = label && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, labelProps, {
    id: labelId,
    className: labelClasses
  }), label);
  var passChildProps = function passChildProps(child) {
    if (child.displayName === 'SkipLink') {
      return {
        inList: true
      };
    }
    return null;
  };
  return /*#__PURE__*/_react.default.createElement(RootElement, listItemProps, expandable ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, expandable === null || expandable === void 0 ? void 0 : expandable.expandButtonProps, {
    "aria-describedby": generatedIDs,
    "aria-expanded": expanded,
    "aria-label": expanded ? expandable === null || expandable === void 0 || (_expandable$localized = expandable.localizedText) === null || _expandable$localized === void 0 ? void 0 : _expandable$localized.textCollapse : expandable === null || expandable === void 0 || (_expandable$localized2 = expandable.localizedText) === null || _expandable$localized2 === void 0 ? void 0 : _expandable$localized2.textExpand,
    className: classnames("".concat(CSS_BLOCK, "__expand-button"), (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__expand-button--collapsed"), !expanded)),
    onClick: function onClick(e) {
      var _expandable$onToggle2;
      var isExpanded = !expanded;
      setExpanded(isExpanded);
      expandable === null || expandable === void 0 || (_expandable$onToggle2 = expandable.onToggle) === null || _expandable$onToggle2 === void 0 || _expandable$onToggle2.call(expandable, e, isExpanded);
    },
    onKeyDown: onExpandButtonKeyDown,
    role: "button",
    tabIndex: "0"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames("".concat(CSS_BLOCK, "__expand-icon")),
    iconName: expanded ? 'arrow-2-n' : 'arrow-2-s',
    size: "xs-plus"
  }), labelContent) : labelContent, /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, listPrefixContent), /*#__PURE__*/_react.default.createElement(ListElement, (0, _extends2.default)({}, otherProps, {
    "aria-labelledby": generatedIDs,
    className: classes,
    ref: ref
  }), children));
});
ListGroup.displayName = 'List.Group';
ListGroup.propTypes = {
  /** Content consisting of List.Item components. */
  children: _propTypes.default.node,
  /** CSS classes to add to the list element. */
  className: _propTypes.default.string,
  /** Enables expanding behavior.
   *
   * `expandButtonProps` (object): Additional props to be spread
   * to the expand button element.
   *
   * `isExpanded` (boolean): Set to `true` to set the list / group to be expanded by default.
   *
   * `onToggle` (function): Callback function when the group is expanded or collapsed
   *
   * `localizedText` (shape): Localized text to be updated based on location/language.
   * `textCollapse`: Assistive text for the toggle button when expanded.
   * `textExpand`: Assistive text for the toggle button when collapsed.
   */
  expandable: _propTypes.default.shape({
    expandButtonProps: _propTypes.default.object,
    isExpanded: _propTypes.default.bool,
    onToggle: _propTypes.default.func,
    localizedText: _CustomPropTypes.default.i18n({
      textCollapse: _CustomPropTypes.default.localizedString('CoreUIComponents.collapse'),
      textExpand: _CustomPropTypes.default.localizedString('CoreUIComponents.expand')
    }).isRequired
  }),
  /** @ignore */
  isRoot: _propTypes.default.bool,
  /** The content to render as a label of the group. */
  label: _propTypes.default.node,
  /** Additional props to spread to the label content `<div>` element. */
  labelProps: _propTypes.default.object,
  /** Node to place between the label content and `<ul>` or `<ol>`. */
  listPrefixContent: _propTypes.default.node
};
var _default = exports.default = ListGroup;